import { render, staticRenderFns } from "./CardOneList.vue?vue&type=template&id=bb66aea6&scoped=true"
import script from "./CardOneList.vue?vue&type=script&lang=js"
export * from "./CardOneList.vue?vue&type=script&lang=js"
import style0 from "./CardOneList.vue?vue&type=style&index=0&id=bb66aea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66aea6",
  null
  
)

export default component.exports